import React from 'react';
import styled from 'styled-components';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const PartnersSection = styled.section`
  padding: 4rem 0rem;
  background: ${props => props.theme.colors.background};
  border-bottom: 1px solid ${props => props.theme.colors.background};
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
`;

const LogoSlider = styled.div`
  margin: 0 -20px;
  overflow: hidden;
  
  .slick-list {
    overflow: hidden;
  }
  .slick-slide {
    display: flex !important;
    justify-content: center;
    align-items: center;
    padding: 0 20px;
  }

  .slick-track {
    display: flex !important;
    align-items: center;
  }

  .slick-prev, .slick-next {
    width: 40px;
    height: 40px;
    z-index: 1;
    
    &:before {
      font-size: 40px;
      color: ${props => props.theme.colors.primary};
      opacity: 0.5;
    }

    &:hover:before {
      opacity: 1;
    }
  }

  .slick-prev {
    left: -50px;
  }

  .slick-next {
    right: -50px;
  }
`;

const Logo = styled.img.attrs(() => ({ loading: 'lazy' }))`
  max-height: 60px;
  width: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0.7;
  transition: all 0.3s ease;
  margin: 0 auto;
  filter: grayscale(100%);

  &:hover {
    opacity: 1;
    transform: scale(1.05);
    filter: grayscale(0%);
  }
       @media (max-width: 768px) {
     max-height: 60px;

  }
`;

const SingleLogo = styled.img`
  max-height: 80px;
  width: auto;
  display: block;
  margin: 0 auto;
  opacity: 0.8;
  transition: all 0.3s ease;
  filter: grayscale(50%);

  &:hover {
    opacity: 1;
    transform: scale(1.05);
    filter: grayscale(0%);
  }

  @media (max-width: 768px) {
    max-height: 60px;
  }
`;

const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: 700;
  text-align: center;
  margin-bottom: 2rem;
  color: ${props => props.theme.colors.primary};
`;

const SectionWrapper = styled.div`
  margin-bottom: 3rem;
  &:last-child {
    margin-bottom: 0;
  }
`;



function Partners() {
  const settings = {
    dots: false,
    infinite: true,
    speed: 3000,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: 'linear',
    pauseOnHover: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        }
      }
    ]
  };

  // Collaborations
  const baseCollaborations = [
    {
      name: 'IFIAG',
      logo: '/images/logo-ifiag-site2.png'
    },
    {
      name: 'Enactus',
      logo: '/images/logo-sponsor-collab/Enactus_Full_Color_logo.png'
    },
    {
      name: 'Tawasol',
      logo: '/images/logo-sponsor-collab/tawasol-logo.png'
    },
    {
      name: 'Diriddik',
      logo: '/images/diriddik-removebg-preview.png'
    },
    {
      name: 'TBH',
      logo: '/images/Tbh-logo-3d.png'
    }
  ];

  // Double arrays for smooth infinite scroll
  const collaborations = [...baseCollaborations, ...baseCollaborations];

  const renderSlider = (items, key) => (
    <LogoSlider key={key}>
      <Slider {...settings}>
        {items.map((item, index) => (
          <Logo
            key={index}
            src={process.env.PUBLIC_URL + item.logo}
            alt={item.name}
          />
        ))}
      </Slider>
    </LogoSlider>
  );



  return (
    <PartnersSection>
      <Container>
        <Title>Grateful for These Collaborations</Title>

        <SectionWrapper>
          {/* <SectionTitle>Grateful for These Collaborations</SectionTitle> */}
          {renderSlider(collaborations, 'collaborations')}
        </SectionWrapper>

        {/* <SectionWrapper>
          <SectionTitle>Past Sponsors</SectionTitle>
          <Description>
            Sidi Ali generously supported our actions in the past. We are grateful for their contribution.
          </Description>
          {renderSingleLogo(basePastSponsors[0])}
        </SectionWrapper>

        <SectionWrapper>
          <SectionTitle>Current Partners</SectionTitle>
          <Description>
            Intelcia is our active partner today, working closely with us to make a difference.
          </Description>
          {renderSingleLogo(baseCurrentPartners[0])}
        </SectionWrapper> */}
      </Container>
    </PartnersSection>
  );
}

export default Partners;
